<template>
  <div
    v-if="options"
    class="w-full col-span-full"
  >
    <p
      v-html="libelle"
      :for="name"
      class="text-lg text-indigo-600 truncate mb-2"
      :style="(inherits != undefined && inherits != null && inherits) ? 'color: inherit; font-size: inherit; font-weight: inherit;' : ''"
    />
    <div class="relative">
      <input
        class="select-input bg-white border border-indigo-600 border-opacity-50 rounded-md
                placeholder-gray-600
                block w-full
                focus:outline-none focus:shadow-outline-indigo focus:border-indigo-300
                appearance-none transition duration-150 ease-in-out
                sm:leading-5"
        :class="{
          'bg-gray-200 text-gray-600 cursor-not-allowed': disabled || disabled_pass,
          'text-lg py-5 px-5': big != null && big,
          'text-sm pl-3 pr-7 py-2 xxl:pl-4 xxl:pr-8 xxl:py-3 2xl:pl-5 2xl:pr-9 2xl:py-4': big == null || !big,
          'cursor-pointer': hasChevron
        }"
        :name="name"
        @focus="showOptions()"
        @keyup="keyMonitor"
        v-model="searchFilter"
        :disabled="disabled"
        :placeholder="placeholder" 
        autocomplete="off"
      >
      <div
        v-if="!disabled && hasChevron" 
        class="pointer-events-none absolute inset-y-0 right-0 flex items-center text-pink-600 px-4"
      >
        <icon name="chevron-down" />
      </div>
      <div
        v-click-outside="exit"
        class="absolute bg-white overflow-auto z-10 w-full max-h-60 rounded-md shadow-lg shadow-gray-600 p-4"
        :hidden="!optionsShown || !filteredOptions.length > 0"
      >
        <div
          class="cursor-pointer first:pt-3 pb-5 lg:pb-3 font-normal hover:font-medium text-base lg:text-sm last:pb-1 text-gray-600"
          v-for="(option, index) in filteredOptions"
          :key="index"
        >
          <span @click="selectOption(option)">
            {{ option.name || option.value || '-' }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from './../Icon.vue';
import ClickOutside from 'vue-click-outside';

export default {
  components:{
    Icon,
  },
  name: 'InputDropDown',
  template: 'InputDropDown',
  props: {
    name: {
      type: String,
      required: false,
      default: 'dropdown',
      note: 'Input name'
    },
    options: {
      type: Array,
      required: true,
      default: ()=>[],
      note: 'Options of dropdown. An array of options with id and name',
    },
    placeholder: {
      type: String,
      required: false,
      default: '',
      note: 'Placeholder of dropdown'
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
      note: 'Disable the dropdown'
    },
    disabled_pass: {
      type: Boolean,
      required: false,
      default: false,
      note: 'Disable the dropdown'
    },
    big: {
      type: Boolean,
      required: false,
      default: false,
      note: 'Disable the dropdown'
    },
    maxItem: {
      type: Number,
      required: false,
      default: 20,
      note: 'Max items showing'
    },
    libelle: {
      type: String,
      required: false,
      default: ''
    },
    inherits :{
      type: Boolean,
      required: false,
      default:false,
    },
    hasChevron:{
      type: Boolean,
      required: false,
      default:false,
    }
  },
  data() {
    return {
      selected: {},
      optionsShown: false,
      searchFilter: ''
    };
  },
  created() {
    this.$emit('selected', this.selected);
  },
  computed: {
    filteredOptions() {
      let filteredList = [];

      filteredList = [...this.options].filter(opt => opt.name.toLocaleLowerCase().includes(this.searchFilter.toLocaleLowerCase()));
            
      return filteredList;
    }
  },
  methods: {
    selectOption(option) {
      //console.log('select', option.id)
      if (option.id === 0){
        this.selected = {};
        this.searchFilter = '';
        this.$emit('selected', {});
      }else {
        this.selected = option;
        // console.log("what a selected", this.selected);
        this.searchFilter = option.name;
        this.$emit('selected', option);
      }
      this.optionsShown = false;
      // console.log('selected', this.selected.id)
    },
    showOptions(){
      if (!this.disabled) {
        // console.log('showing', this.selected.id)
        this.selected = {};
        this.searchFilter = '';
        this.optionsShown = true;
        this.$emit('selected', {});
        // console.log('showed', this.selected.id)
      }
    },
    exit(e) {
      if (e.target.classList.contains('select-input') && e.target.name === this.name) {
        this.showOptions();
        return;
      }
      if (this.optionsShown) {
        this.optionsShown = false;
        //console.log('exited', this.selected);
      }
    },
    // Selecting when pressing Enter
    keyMonitor: function(event) {
      if (event.key === 'Enter' && this.filteredOptions[0])
        this.selectOption(this.filteredOptions[0]);
    }
  },
  watch: {
    searchFilter() {
      // console.log('filtering', this.selected.id)
      if (this.filteredOptions.length === 1 && this.searchFilter === '') {
        this.optionsShown = false;
        this.selected = {};
      } 
      else if(this.searchFilter === ''){
        this.$emit('foundResult');
      }
      else if (this.searchFilter !== '') {
        if(this.filteredOptions.length === 0){
          this.$emit('noResult');
        }
        if(this.filteredOptions.length > 0){
          this.$emit('foundResult');
        }
        this.optionsShown = true;
        this.selected = this.filteredOptions[0];
      }
      this.$emit('filter', this.searchFilter);
      // console.log('filtered', this.selected.id)
    },

    options() {
      // console.log('watching options', this.selected.id)
      if (this.options.length === 0){
        // console.log('watching options', 'no result')
        this.$emit('noResult');
      }else {
        this.$emit('foundResult');
      }
      this.selected = {};
      this.searchFilter = '';
    }
  },

  directives: {
    ClickOutside,
  },
};
</script>
